import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Toast } from './shared/toast/toast';
import { LoadingSpinner } from './shared/loading-spinner/loading-spinner';
import { SalonStore } from './core/store/salon.store';
import { Header } from './shared/header/header';
import { Footer } from './shared/footer/footer';
import { TranslatePipe } from '@concretecode/data';

@Component({
  imports: [RouterModule, Toast, LoadingSpinner, TranslatePipe, Header, Footer],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly #salonStore = inject(SalonStore);

  protected readonly isLoading = this.#salonStore.isLoading;
  protected readonly title = this.#salonStore.name;
}
